import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { SiteVsRunReport } from "../components";


class SiteVsRunReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "report",
            title: "Site vs Run report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Site vs Run report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <SiteVsRunReport />
            </Base>
        );
    }
}

export default SiteVsRunReportContainer;
